import _ from 'lodash';
import {formatDateForApi} from 'utils/datetime';

export const prepareFormData = (
  data,
  locationRef,
  invoiceId,
  tenancyId,
  scheduleType
) => {
  const postData = {
    ...data,
    dateIssued: formatDateForApi(_.get(data, 'dateIssued')),
    rentStart: formatDateForApi(_.get(data, 'rentStart')),
    rentEnd: formatDateForApi(_.get(data, 'rentEnd')),
    location: locationRef,
    account: _.get(data, 'account.id'),
    taxRate: data['taxRate'].value,
    tenancyId,
    scheduleType
  };

  if (invoiceId) {
    postData['invoice'] = invoiceId;
  }

  delete postData['tax'];

  return postData;
};
